import Vue from "vue";
import Treeselect from "@riophae/vue-treeselect";
Vue.use(Treeselect);
Vue.component("tree-select", Treeselect);
